import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { QuizAttempt, Quiz } from '@/types/quiz';

export const useQuizAttemptById = (attemptId?: string) => {
  const [attempt, setAttempt] = useState<QuizAttempt | null>(null);
  const [quiz, setQuiz] = useState<Quiz | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAttempt = async () => {
      if (!attemptId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        // Fetch the quiz attempt with quiz details
        const { data: attemptData, error: attemptError } = await supabase
          .from('quiz_attempts')
          .select(`
            *,
            quiz:quizzes(*),
            player:players(
              *,
              profile:profiles(*)
            )
          `)
          .eq('id', attemptId)
          .single();

        if (attemptError) {
          if (attemptError.code === 'PGRST116') {
            setError('Quiz attempt not found');
          } else {
            throw attemptError;
          }
          return;
        }

        if (!attemptData) {
          setError('Quiz attempt not found');
          return;
        }

        setAttempt(attemptData);
        setQuiz(attemptData.quiz);
      } catch (err) {
        console.error('Error fetching quiz attempt:', err);
        setError('Failed to load quiz results');
        toast.error('Failed to load quiz results');
      } finally {
        setLoading(false);
      }
    };

    fetchAttempt();
  }, [attemptId]);

  return {
    attempt,
    quiz,
    loading,
    error
  };
};